import { Component, Input } from "@angular/core";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { PonderAuthClient } from "@apiserver-rest/ponder-auth-client";
import { AuthSession } from "@ponder-core/auth/auth-session";
import { AuthService } from "@ponder-core/auth/auth.service";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { BusySpinComponent } from "@ponder-shared/components/busy-spin.component";

@Component({
    selector: "user-password-change",
    imports: [BusySpinComponent, ReactiveFormsModule],
    templateUrl: "./user-account-password-change.component.html"
})
export class UserAccountPasswordChangeComponent {
    @Input({ required: true }) public authSession?: AuthSession;
    
    public updatePasswordForm!: FormGroup;
    public isUpdating: boolean = false;
    public updateErrors?: string = undefined;

    public isPasswordChangeValid: boolean = false;
    public invalidPasswordReasons: string[] = [];

    public constructor(formBuilder: FormBuilder, private ponderAuthClient: PonderAuthClient, private authService: AuthService, private events: EventBroker) {
        this.updatePasswordForm = formBuilder.group({
            old: ["", [Validators.required, Validators.minLength(8), Validators.maxLength(64)]],
            new: ["", [Validators.required, Validators.minLength(8), Validators.maxLength(64)]],
            confirm: ["", [Validators.required, Validators.minLength(8), Validators.maxLength(64)]]
        });

        this.updatePasswordForm.valueChanges.subscribe(() => { this.onPasswordChanged(); });
    }

    private onPasswordChanged(): void {
        this.isPasswordChangeValid = true;
        this.invalidPasswordReasons = [];

        var newPassword = this.updatePasswordForm.get("new")!.value as string | undefined;
        var confirmPassword = this.updatePasswordForm.get("confirm")!.value as string | undefined;

        if (newPassword?.length) {
            if (newPassword.length < 8 || newPassword.length > 64) {
                this.isPasswordChangeValid = false;
                this.invalidPasswordReasons.push("Password must be between 8 and 64 characters.");
            }

            if (confirmPassword?.length) {
                if (confirmPassword != newPassword) {
                    this.isPasswordChangeValid = false;
                    this.invalidPasswordReasons.push("Passwords do not match!");
                }
            }
        }
    }

    public canSubmitPasswordChange(): boolean {
        return this.updatePasswordForm.valid && this.isPasswordChangeValid && !this.isUpdating;
    }

    public async onChangePasswordClicked(): Promise<void> {
        if (!this.canSubmitPasswordChange()) {
            return;
        }
        
        this.isUpdating = true;
        this.updateErrors = undefined;
        this.updatePasswordForm.disable();
        
        const oldPassword = this.updatePasswordForm.get("old")!.value;
        const newPassword = this.updatePasswordForm.get("new")!.value;

        try {
            const [success, error] = await this.authService.changePasswordAsync(oldPassword, newPassword);
    
            if (success) {
                await this.authService.logOutAsync();
            } else {
                this.updateErrors = error;
                this.isUpdating = false;
                this.updatePasswordForm.enable({ emitEvent: false });
            }
        } catch {
            this.updateErrors = "Password update failed.";
            this.isUpdating = false;
            this.updatePasswordForm.enable({ emitEvent: false });
        }
    }
}